import Service from "../AuthService";
import moment from "moment";

const Account = {
  getDocuments() {
    return Service.get(`documents`);
  },
  getDocumentType() {
    return Service.get(`document-type`);
  },
  getApproveOrder() {
    return Service.get(`approve-order`);
  },
  filterOrder(request) {
    return Service.get(
      `approve-order?hospital_id=${request.hospital_id}&start_date=${request.start_date}&end_date=${request.end_date}`
    );
  },
  filterDocument(request) {
    return Service.get(
      `documents?page=${request.page_no}&in=${request.in}&direction_id=${
        request.direction_id
      }&hospital_id=${request.hospital_id}&corporation_id=${
        request.corporationId
      }&start_date=${request.start_date}&end_date=${
        request.end_date
      }&document_type_id=${request.document_type_id}&other_corporation_id=${
        request.otherCorporationId
      }&payment_status=${
        request.paymentStatus ? request.paymentStatus.id : ""
      }&no_invoice=${request.noInvoice ? request.noInvoice : false}`
    );
  },
  generateIn() {
    return Service.get(`generate-in`);
  },
  generateTi() {
    return Service.get(`generate-ti`);
  },
  createDocument(payload) {
    return Service.post(`create-document`, payload);
  },
  getDocument(id) {
    return Service.get(`document/${id}`);
  },
  editDocument(payload) {
    return Service.put(`document/${payload.id}`, payload);
  },
  deleteDocument(id) {
    return Service.delete(`document/${id}`);
  },
  payment(payload) {
    return Service.post(`document-payment/${payload.id}`, payload);
  },
  getPlatforms() {
    return Service.get(`platform-accounts`);
  },
  getPaymentStatuses() {
    return Service.get(`payment-status`);
  },
  createBlankForm(payload) {
    return Service.post(`create-blank-document`, payload);
  },
  getBlankForm(id) {
    return Service.get(`get-blank-document/${id}`);
  },
  editBlankForm(payload, id) {
    return Service.put(`edit-blank-document/${id}`, payload);
  },
  deleteBlankForm(id) {
    return Service.delete(`delete-blank-document/${id}`);
  },
  statFilter(payload) {
    return Service.get(`stat-filter`, { params: payload });
  },
  reportInvoiceFilter(payload) {
    return Service.get(`report-invoice-filter`, { params: payload });
  },
  reportTestFilter(payload) {
    return Service.get(`report-test-filter`, { params: payload });
  },
  reportAnimalFilter(payload) {
    return Service.get(`report-animal-filter`, { params: payload });
  },
  reportSpecimenFilter(payload) {
    return Service.get(`report-specimen-filter`, { params: payload });
  },
  uploadGraphImage(base64) {
    return Service.post(`report-stat-graph-upload`, {
      base64,
    });
  },
  statPrint(payload) {
    return Service.post(`report-stat`, payload);
  },
  statExcel(payload) {
    return Service.post(`excel-stat`, payload);
  },
  reportPrint(payload) {
    return Service.post(`report-print`, payload);
  },
  reportPrintExcel(payload) {
    return Service.post(`report-print-excel`, payload);
  },
  getOrderLabInvoice(hospitalId, documentId = null, date = null) {
    let url = `lab-invoices`;

    if (hospitalId) {
      url += `?hospitalId=${hospitalId}`;
    }

    if (documentId) {
      url += `&documentId=${documentId}`;
    }

    if (date) {
      url += `&date=${moment(date).format("DD-MM-Y")}`;
    }
    return Service.get(`${url}`);
  },
  getOrderLabInvoiceByLN(ln, documentId = null) {
    let url = `lab-invoices/${ln}`;

    if (documentId) {
      url += `?documentId=${documentId}`;
    }
    return Service.get(`${url}`);
  },
  createManualLabInvoice(ln, payload) {
    return Service.post(`lab-invoices/${ln}`, payload);
  },
  updateManualLabInvoice(id, payload) {
    return Service.put(`lab-invoices/${id}`, payload);
  },
  updateManualLabInvoiceDetail(ln, payload) {
    return Service.put(`lab-invoices-update/${ln}`, payload);
  },
  deleteManualLabInvoice(id) {
    return Service.delete(`lab-invoices/${id}`);
  },
  getLabPromotions() {
    return Service.get(`get-promotions`);
  },
  getTestPrice(id, specieId) {
    return Service.get(`test-price/${id}/${specieId}`);
  },
  getSetTestPrice(id, specieId) {
    return Service.get(`set-test-price/${id}/${specieId}`);
  },
  getItemInvoices(id) {
    return Service.get(`item-invoices/${id}`);
  },
  getPromotions(query) {
    let url = `settings/lab-promotions`;
    const keyQueryList = Object.keys(query);
    Object.entries(query).forEach((value, key) => {
      if (key === keyQueryList[0]) {
        url += `?`;
      }
      url += `${key}=${value}`;
      if (key !== keyQueryList[keyQueryList.length - 1]) {
        url += `&`;
      }
    });
    return Service.get(`${url}`);
  },
  getPromotionById(id) {
    return Service.get(`settings/lab-promotions/${id}`);
  },
  createPromotion(payload, token) {
    return Service.post(`settings/lab-promotions?token=${token}`, payload);
  },
  updatePromotion(id, payload, token) {
    return Service.put(`settings/lab-promotions/${id}?token=${token}`, payload);
  },
  deletePromotion(id, token) {
    return Service.delete(`settings/lab-promotions/${id}?token=${token}`);
  },
  printDocument(documentSelected, id, isCopy) {
    let url = `document-print/${documentSelected}?id=${id}`;
    if (isCopy !== null) {
      url += `&isCopy=${isCopy}`;
    }
    return Service.get(`${url}`);
  },
  getBankAccounts(corporationId, corporationType) {
    return Service.get(
      `corporation-accounts?corporation_id=${corporationId}&corporation_type=${corporationType}`
    );
  },
};

export default Account;
